export var cellProps = {
  icon: String,
  center: Boolean,
  isLink: Boolean,
  required: Boolean,
  titleClass: String,
  valueClass: String,
  labelClass: String,
  title: [String, Number],
  value: [String, Number],
  label: [String, Number],
  border: {
    type: Boolean,
    default: true
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/cell/shared.js
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7